import { MultilegComboType } from '@src/components/MultilegCombo/enums';
import { getMultilegInstrumentType } from '@src/components/OMS/NewOrder/utils/mappers';
import { useAppLayoutContext } from '@src/providers/AppLayoutContextProvider';
import type { MixpanelEventSource } from '@talos/kyoko';
import { MixpanelEvent, MixpanelEventProperty, useCallbackRef, useMixpanel, type Security } from '@talos/kyoko';

export function useCloneMultilegSymbol(source: MixpanelEventSource) {
  const { addMultilegDeepDivePanel } = useAppLayoutContext();
  const mixpanel = useMixpanel();

  const cloneMultilegSymbol = useCallbackRef((security: Security) => {
    const multilegInstrumentType =
      getMultilegInstrumentType(security?.MultilegDetails?.SyntheticProductType) ?? MultilegComboType.SyntheticCross;

    mixpanel.track(MixpanelEvent.CloneMultileg, {
      [MixpanelEventProperty.Source]: source,
    });

    addMultilegDeepDivePanel({
      security,
      multilegInstrumentType,
      isClone: true,
    });
  });

  return cloneMultilegSymbol;
}
